import { SelectOptionType } from '@octano/global-ui';
import { OutlinedSelectOptionType } from '@octano/global-ui';
import { PaginationRequestType } from '../../../types/paginationRequestType';

export type ClassroomResponseType = PaginationRequestType<ClassroomApiResponse>;

/**
 * Motivo por el que la API rechaza eliminar o deshabilitar una sala. Viaja en
 * el cuerpo del 409 (`ClassroomBlockingReason` del backend).
 */
export enum ClassroomBlockingReason {
  HasCurrentOrFutureReservations = 'HAS_CURRENT_OR_FUTURE_RESERVATIONS',
  HasPastReservations = 'HAS_PAST_RESERVATIONS',
}

export interface Classroom {
  id: number;
  name: string;
  code: string;
  campusId: number;
  capacity: number;
  description: string | null;
  isEnabled: boolean;
  typeId: string;
}

export interface ClassroomApiResponse extends Classroom {
  campus: string;
  type: string;
  hasPastReservations: boolean;
  currentOrFutureReservations: ClassroomReservation;
}

export interface ClassroomReservation {
  events: EventReservationDetail[];
  lessons: LessonReservationDetail[];
}

export interface LessonReservationDetail {
  id: number;
  startDate: string;
  endDate: string;
  sectionId: number;
  sectionCode: string;
  subjectName: string;
  type: string;
  schedule: {
    startModule: TimeModule;
    endModule: TimeModule;
  };
}

export interface EventReservationDetail {
  id: number;
  date: string;
  eventName: string;
  type: string;
  schedule: {
    startModule: TimeModule;
    endModule: TimeModule;
  };
}

export interface TimeModule {
  id: number;
  name: string;
  startTime: string;
  endTime: string;
}

export interface ClassroomsLoaderQuery {
  items: number;
  page: number;
  name?: string;
  code?: string;
  type?: number;
  campus?: number;
  state?: string;
}

export interface ClassroomsFilterData {
  classroomCodes: ClassRoomCode[];
  classroomTypes: ClassRoomType[];
  campuses: ClassRoomCampus[];
}

interface ClassRoomCode {
  id: number;
  code: string;
}

interface ClassRoomType {
  id: number;
  name: string;
}

interface ClassRoomCampus {
  id: number;
  name: string;
}

export interface SearchControlsForm {
  name: string | null;
  code: OutlinedSelectOptionType | null;
  type: OutlinedSelectOptionType | null;
  campus: OutlinedSelectOptionType | null;
  state: OutlinedSelectOptionType | null;
}

export type ClassroomBaseRelation = {
  id: number | string;
  name: string;
};

export type ClassroomSelectOptionType = SelectOptionType & {
  extra?: Record<string, any>;
};

export type ClassroomFormData = {
  types: ClassroomSelectOptionType[];
  campuses: ClassroomSelectOptionType[];
};

export type ClassroomFormFields = {
  code: string;
  name: string;
  capacity: number;
  description: string;
  type: SelectOptionType | null;
  campus: SelectOptionType | null;
};

export type ClassroomFormRequest = {
  code: string;
  name: string;
  capacity: number;
  description: string | null;
  typeId: string;
  campusId: number;
  id?: number;
};

export type ClassroomBody = {
  id: number;
  code: string;
  name: string;
  capacity: number;
  description: string | null;
  typeId: string;
  campusId: number;
};

export type RecordToEditBody = ClassroomBody & {
  isEnabled: boolean;
  campus: ClassroomBaseRelation;
  type: ClassroomBaseRelation;
};

export type ClassroomOptionsResponse = {
  types: ClassroomSelectOptionType[];
  campuses: ClassroomSelectOptionType[];
};
